// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IOVF', 'IOVF Fallback'"},"className":"__className_791501","variable":"__variable_791501"};